import { HttpContextToken, HttpInterceptorFn } from "@angular/common/http";

export const httpResponseInterceptor: HttpInterceptorFn = (req, next) => {
  let newReq = req;
  if (req.url.includes("/pdf") || req.url.includes("/docx")) {
    newReq = req.clone({ responseType: req.context.get(new HttpContextToken(() => "blob")) });
  }

  return next(newReq);
};
